import useAxios from "config/RequestInterceptor";
import {useQuery} from "react-query";

const getArticles = async () => {
    return await useAxios.get('/api/articles?populate=*').then(data => (data.data.data))
}

const time = {
    staleTime: 60 * 1000 * 15,
    cacheTime: 60 * 1000 * 30
};

export const useGetArticles = () => {
    return useQuery(
        'get-all-articles',
        getArticles,
        time
    );
}